module.exports = __webpack_public_path__ + "static/media/5.281bc2b6.JPG";